import React, { Component } from 'react';
import Select from 'react-select';
import _ from 'lodash';
import { connect } from 'react-redux';
import { MdSearch, MdRefresh } from 'react-icons/lib/md';
import { FaFileExcelO } from 'react-icons/lib/fa';
import { DateField } from '../detail/schedule_utils';
import { withAuth } from '../../actions/';
import { getOptionsForProjectType, getOptionsForProgramType } from '../detail/utils';
import { fetch_lkp_ProjectProgramType, fetch_lkp_ProjectType } from '../../actions/additional_actions';
import { fetchGisCityCouncils, fetchGisAssemblyDist, fetchGisCommBoard, fetchGisStateSenateDist, fetchGisUSCongressionalDist } from '../../actions/project_actions';
import { fetchProjectsAdvance, setEmptyProjects } from '../../actions/projects_actions';
import { formatDate } from '../../utils/';
import { formatMoney } from '../../utils/budget';
import { fetchInternalTeam, fetchExternalTeam } from '../../actions/additional_actions';

const INFRASTRUCTURE = 'Infrastructure';

const PUBLICBUILDING = 'Public Buildings';

class AdvanceSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projectId: '',
            divisionName: '',
            unitName: '',
            phaseName: '',
            subPhase: '',
            sponsor: '',
            since1996: '',
            advanceSearchProjectTypesSelected: [],
            advanceSearchProgramTypeSelected: '',
            designFiscalYear: [],
            constructionFiscalYear: [],
            designBy: '',
            designGroup: '',
            cmBoro: '',
            isFHWA: '',
            isHiddenVendor: true,
            regNumber: '',
            vendorName: '',
            regDateFrom: '',
            regDateTo: '',
            borough: '',
            communityBoard: '',
            cityCouncil: '',
            assemblyDist: '',
            stateSenateDist: '',
            usCongressionalDist: '',
            isHiddenGeo: true,
            paunit: '',
            isHiddenTeam: true,
            queryMembers: '',
            queryConsultants: '',
            showInternalDd: false,
            showExternalDd: false,
            internalMemberId: '',
            externalConsultantId: '',
        };

        this.handleAdvanceSearch = this.handleAdvanceSearch.bind(this);
        this.handleChangeProjectId = this.handleChangeProjectId.bind(this);
        this.handleAdvanceSearchExcel = this.handleAdvanceSearchExcel.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleSelectChangeMulti = this.handleSelectChangeMulti.bind(this);
        this.handleSelectChangeStatusMulti = this.handleSelectChangeStatusMulti.bind(this);
        this.handleSelectChangeCfyMulti = this.handleSelectChangeCfyMulti.bind(this);
        this.handleSelectChangeDesignFyMulti = this.handleSelectChangeDesignFyMulti.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleTeamSearch = this.handleTeamSearch.bind(this);

        this.toggleVendorInfo = this.toggleVendorInfo.bind(this);
        this.toggleGeoLocations = this.toggleGeoLocations.bind(this);
        this.toggleProjectTeam = this.toggleProjectTeam.bind(this);
        this.selectMember = this.selectMember.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { projectTypes, gisCouncil, gisAssemblyDist, gisCommBoard, gisStateSenateDist, gisUSCongressionalDist } = this.props;

        if (projectTypes.length === 0) this.props.fetch_lkp_ProjectType();
        if (gisCouncil.length === 0) this.props.fetchGisCityCouncils();
        if (gisAssemblyDist.length === 0) this.props.fetchGisAssemblyDist();
        if (gisCommBoard.length === 0) this.props.fetchGisCommBoard();
        if (gisStateSenateDist.length === 0) this.props.fetchGisStateSenateDist();
        if (gisUSCongressionalDist.length === 0) this.props.fetchGisUSCongressionalDist();

        this.props.fetch_lkp_ProjectProgramType();
    }

    getOptionsForDivision(field) {
        const values = ['Infrastructure', 'Public Buildings'];
        return values.map(value => {
            return { label: value, value: value }
        });
    }

    getOptionsForPhase(field) {
        //const values = this.props.setup["projectPhases"];
        const values = _.uniqBy(this.props.subPhases.filter(c => c.divisionName === this.state.divisionName), 'phaseName');
        if (values) {
            return values.map(value => {
                return { label: value.phaseName, value: value.phaseName }
            });
        }
    }

    getOptionsForUnit(field) {
        const values = ['ACS', 'Borough Based Jails', 'BRONX & N. QUEENS', 'BROOKLYN', 'CORRECTIONS', 'Courts', 'CULTURALS', 'DCAS', 'DEP', 'EXECUTIVE', 'Fire', 'HEALTH', 'HUMAN SERVICES',
            'Integrated Executive Projects(PB)', 'LIBRARIES', 'MANHATTAN & CITYWIDE', 'Miscellaneous', 'NYCEM', 'ONENYC', 'Parks', 'Pass Through', 'POLICE', 'S. QUEENS',
            'SANITATION', 'STATEN ISLAND', 'Transportation'];
        return values.map(value => {
            return { label: value, value }
        });
    }

    getOptionsForSponsor(field) {
        const values = ['Aging', 'Children Services', 'Corrections', 'Cultural Affairs', 'DCAS', 'Department of Design and Construction',
            'Education', 'Emergency Management', 'Environmental Protection', 'Fire', 'Health', 'Health & Hospitals Corporation (HHC)',
            'Homeless Services', 'HPD', 'Libraries-BPL', 'Libraries-NYPL', 'Libraries-QBPL',
            'Mayors Office Operations', 'Mayors Office of Resiliency (MOR)', 'NYCHA', 'OCME', 'OEM', 'Parks & Recreation', 'Police', 'Records & Information Services', 'Sanitation',
            'SocialServices-HRA', 'Trans. & Env. Protection', 'Transportation'];
        return values.map(value => {
            return { label: value, value }
        });
    }

    getOptionsForFiscalYear(field) {
        const today = new Date();
        const targetYear = today.getFullYear() + 7;
        let fiscalYears = [];

        let year;
        for (year = 2008; year <= targetYear; year++)
            fiscalYears.push({ label: year.toString(), value: year });

        return fiscalYears;
    }

    getOptionsForDesignBy(field) {
        const values = ['In-House', 'External'];
        return values.map(value => {
            return { label: value, value }
        });
    }

    getOptionsForProjectDeliveryMethod(field) {
        const values = ['CM Build', 'Design Bid Build', 'Traditional Design Build', 'Progressive Design Build'];
        return values.map(value => {
            return { label: value, value }
        });
    }

    getOptionsFor(propertyValue) {
        if (this.props[propertyValue] === undefined)
            return;

        return this.props[propertyValue].map(value => {
            return { label: value, value }
        });
    }

    getOptionsForCMBoro(field) {
        const values = [
            'Brooklyn',
            'Bronx',
            'Manhattan',
            'Queens',
            'Staten Island',
            'DEP Managed',
            'DOT Managed'];

        return values.map(value => {
            return { label: value, value }
        });
    }

    getOptionsForSubPhase(subPhases) {
        const values = subPhases;//this.state.subPhases.filter(p=>p.phaseName===phaseName);
        if (values.length > 0) {
            return values[0].subPhases.map(value => {
                return { label: value, value }
            });
        }
    }

    getOptionsForBorough(field) {
        const values = ['BK', 'BX', 'MN', 'QN', 'SI'];
        return values.map(value => {
            return { label: value, value }
        });
    }

    getOptionsForComBoard() {
        return this.props.gisCommBoard.map(option => {
            return {
                label: option.nycb,
                value: option.nycb
            }
        });
    }

    getOptionsForcityCouncil() {
        return this.props.gisCouncil.map(option => {
            return {
                label: option.nycc,
                value: option.nycc
            }
        });
    }

    getOptionsForAssemblyDist() {
        return this.props.gisAssemblyDist.map(option => {
            return {
                label: option.nyad,
                value: option.nyad
            }
        });
    }
    getOptionsForStateSenate() {
        return this.props.gisStateSenateDist.map(option => {
            return {
                label: option,
                value: option
            }
        });
    }
    getOptionsForUSCongressional() {
        return this.props.gisUSCongressionalDist.map(option => {
            return {
                label: option,
                value: option
            }
        });
    }
    getOptionsForDesignGroup(field) {
        const values = ['1', '2'];
        return values.map(value => {
            return { label: value, value }
        });
    }

    getOptionsForStatus(field) {
        const values = ['Active', 'On-Hold', 'Completed', 'Cancelled'];
        return values.map(value => {
            return { label: value, value }
        });
    }
    // PAUnit Filter
    getOptionsForPA_Unit(field) {
        const values = ['1', '2', '3', '4', '5'];
        return values.map(value => {
            return { label: value, value }
        });
    }

    selectMember(field, member) {
        if (member === 'internal') {
            return (option) => {
                this.setState({ queryMembers: field.member.firstName + ' ' + field.member.lastName });
                this.setState({ showInternalDd: false });
                this.setState({ internalMemberId: field.memberId });
            }
        }
        else if (member === 'external') {
            return (option) => {
                this.setState({ queryConsultants: field.externalConsultant.firstName + ' ' + field.externalConsultant.lastName });
                this.setState({ showExternalDd: false });
                this.setState({ externalConsultantId: field.externalConsultantId });
            }
        }
    }

    toggleVendorInfo(e) {
        e.preventDefault();
        this.setState({
            isHiddenVendor: !this.state.isHiddenVendor
        })
    }

    toggleGeoLocations(e) {
        e.preventDefault();
        this.setState({
            isHiddenGeo: !this.state.isHiddenGeo
        })
    }

    toggleProjectTeam(e) {
        e.preventDefault();
        this.setState({
            isHiddenTeam: !this.state.isHiddenTeam
        })
    }

    redirectToProject(projectId) {
        window.location = `/projects/${projectId}/`;
    }

    projTypesSelectedToArrProjTypeId(projTypesSelected) {
        let arrPT = [];
        projTypesSelected.forEach((element) => arrPT.push(element.value));
        return arrPT;
    }

    getStatusValuesFromSelectoptions(statusSelectList) {
        let statusArr = [];

        if (statusSelectList) {
            statusSelectList.forEach((e) => statusArr.push(e.value))
        }

        return statusArr;
    }

    fiscalYearToArr(fiscalYearsSelected) {
        let arrCfy = [];
        fiscalYearsSelected.forEach((element) => arrCfy.push(element.value));
        return arrCfy;
    }

    handleChange(field) {
        return (e) => {
            this.setState({ [field]: e.target.value });
        }
    }

    handleDateChangeReg(field) {
        return (date) => {
            this.setState({ [field]: date });
        }
    }

    handleChangeProjectId(field) {
        return (e) => {
            this.setState({ projectId: e.target.value });
        }
    }

    handleCheckboxChange(event) {
        this.setState({ since1996: !this.state.since1996 });
    }

    handleSelectChange(field) {
        return (option) => {
            const value = option ? option.value : null;
            this.setState({ [field]: value });
        }
    }

    handleSelectChangesubPhase(field) {
        return (option) => {
            const value = option ? option.value : null;
            this.setState({ subPhase: value });
        }
    }

    handleSelectChangeMulti(selectedOptions) {
        this.setState({ advanceSearchProjectTypesSelected: selectedOptions });
    }

    handleSelectChangeCfyMulti(selectedOptions) {
        this.setState({ constructionFiscalYear: selectedOptions });
    }

    handleSelectChangeDesignFyMulti(selectedOptions) {
        this.setState({ designFiscalYear: selectedOptions });
    }

    handleSelectChangeStatusMulti(selectedOptions) {
        this.setState({ benchmarkStatus: selectedOptions });
    }

    handleSelectChangeDivision(field) {
        return (option) => {
            const value = option ? option.value : null;

            this.setState({
                divisionName: value, unitName: '', phaseName: '', advanceSearchProgramTypeSelected: '', advanceSearchProjectTypesSelected: []
                , advanceSearchPriority: '', projectDeliveryMethod: '', subPhase: '', designBy: '', designFiscalYear: [], constructionFiscalYear: [], designGroup: '', cmBoro: '', isFHWA: false
            });
        }
    }

    handleSelectChangePhase(field) {
        return (option) => {
            const value = option ? option.value : null;
            this.setState({ phaseName: value, subPhase: '' });
        }
    }

    handleCheckboxChangeFHWA(event) {
        this.setState({ isFHWA: !this.state.isFHWA });
    }

    handleTeamSearch(name) {
        return (e) => {

            if (name === 'member') {
                this.setState({ queryMembers: e.target.value });

                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.props.fetchInternalTeam(this.state.queryMembers);
                }, 200);

                this.setState({ showInternalDd: true });
            }

            else if (name === 'consultant') {
                this.setState({ queryConsultants: e.target.value });

                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.props.fetchExternalTeam(this.state.queryConsultants);
                }, 200);

                this.setState({ showExternalDd: true });
            }

        }
    }

    handleReset() {
        this.setState({
            sponsor: '',
            phaseName: '',
            subPhase: '',
            designFiscalYear: [],
            constructionFiscalYear: [],
            regNumber: '',
            fMSId: '',
            projectId: '',
            divisionName: '',
            advanceSearchProgramTypeSelected: '',
            advanceSearchProjectTypesSelected: [],
            advanceSearchPriority: '',
            projectDeliveryMethod: '',
            unitName: '',
            vendorName: '',
            designGroup: '',
            cmBoro: '',
            benchmarkStatus: '',
            assemblyDist: '',
            communityBoard: '',
            cityCouncil: '',
            stateSenateDist: '',
            usCongressionalDist: '',
            borough: '',
            since1996: '',
            isFHWA: '',
            designBy: '',
            regDateFrom: '',
            regDateTo: '',
            paunit: '',
            internalMemberId: '',
            externalConsultantId: '',
            queryMembers: '',
            queryConsultants: ''
        });

        return this.props.setEmptyProjects();
    }

    handleAdvanceSearch(currentPage) {
        return (e) => {
            e.preventDefault();

            if (!this.state.isHiddenTeam) {
                var internalMemberId = this.state.internalMemberId;
                var externalConsultantId = this.state.externalConsultantId;

                if (internalMemberId === '' && this.state.queryMembers !== '') {
                    internalMemberId = 0;
                }

                if (externalConsultantId === '' && this.state.queryConsultants !== '') {
                    externalConsultantId = 0;
                }
            }

            var criteria = {
                'Sponsor': this.state.sponsor,
                'PhaseName': this.state.phaseName,
                'DesignFiscalYear': this.fiscalYearToArr(this.state.designFiscalYear),
                'ConstructionFiscalYear': this.fiscalYearToArr(this.state.constructionFiscalYear),
                'RegNumber': this.state.regNumber,
                'FMSId': this.state.fMSId,
                'ProjectId': this.state.projectId,
                'DivisionName': this.state.divisionName,
                'UnitName': this.state.unitName,
                'VendorName': this.state.vendorName,
                'DesignGroup': this.state.designGroup,
                'CityCouncileDist': this.state.cityCouncil,
                'CommunityBoard': this.state.communityBoard,
                'AssemblyDistrict': this.state.assemblyDist,
                'StateSenateDist': this.state.stateSenateDist,
                'USCongressionalDist': this.state.usCongressionalDist,
                'Borough': this.state.borough,
                'Since1996': this.state.since1996,
                'DesignBy': this.state.designBy,
                'subPhase': this.state.subPhase,
                'CmBoro': this.state.cmBoro,
                'BenchmarkStatus': this.getStatusValuesFromSelectoptions(this.state.benchmarkStatus),
                'isFHWA': this.state.isFHWA,
                'RegDateFrom': this.state.regDateFrom,
                'RegDateTo': this.state.regDateTo,
                'Priority': this.state.advanceSearchPriority,
                'PAUnit': this.state.paunit,
                'projectTypeIds': this.projTypesSelectedToArrProjTypeId(this.state.advanceSearchProjectTypesSelected),
                'ProgramTypeId': this.state.advanceSearchProgramTypeSelected,
                'InternalMemberId': internalMemberId,
                'ExternalConsultantId': externalConsultantId,
                'ProjectDeliveryMethod': this.state.projectDeliveryMethod
            };

            const { filter } = this.props;
            clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                const params = { data: criteria, currentPage, skip: currentPage * 10 };
                this.props.fetchProjectsAdvance(filter, params);
            }, 300);
        }
    }

    handleAdvanceSearchExcel() {

        if (!this.state.isHiddenTeam) {
            var internalMemberId = this.state.internalMemberId;
            var externalConsultantId = this.state.externalConsultantId;

            if (internalMemberId === '' && this.state.queryMembers !== '') {
                internalMemberId = 0;
            }

            if (externalConsultantId === '' && this.state.queryConsultants !== '') {
                externalConsultantId = 0;
            }
        }

        var criteria = {
            'Sponsor': this.state.sponsor,
            'PhaseName': this.state.phaseName,
            'DesignFiscalYear': this.fiscalYearToArr(this.state.designFiscalYear),
            'ConstructionFiscalYear': this.fiscalYearToArr(this.state.constructionFiscalYear),
            'RegNumber': this.state.regNumber,
            'FMSId': this.state.fMSId,
            'ProjectId': this.state.projectId,
            'DivisionName': this.state.divisionName,
            'UnitName': this.state.unitName,
            'VendorName': this.state.vendorName,
            'DesignGroup': this.state.designGroup,
            'CmBoro': this.state.cmBoro,
            'BenchmarkStatus': this.getStatusValuesFromSelectoptions(this.state.benchmarkStatus),
            'CityCouncileDist': this.state.cityCouncil,
            'CommunityBoard': this.state.communityBoard,
            'AssemblyDistrict': this.state.assemblyDist,
            'StateSenateDist': this.state.stateSenateDist,
            'USCongressionalDist': this.state.usCongressionalDist,
            'Borough': this.state.borough,
            'Since1996': this.state.since1996,
            'DesignBy': this.state.designBy,
            'RegDateFrom': this.state.regDateFrom,
            'regDateTo': this.state.regDateTo,
            'projectTypeIds': this.projTypesSelectedToArrProjTypeId(this.state.advanceSearchProjectTypesSelected),
            'ProgramTypeId': this.state.advanceSearchProgramTypeSelected,
            'PAUnit': this.state.paunit,
            'subPhase': this.state.subPhase,
            'InternalMemberId': this.state.internalMemberId,
            'ExternalConsultantId': this.state.externalConsultantId
        };

        let url = 'projects/advancesearchexcel';
        let method = 'post';
        let responseType = 'arraybuffer';
        withAuth(
            { method, url, responseType, data: criteria },
            (response) => {
                var data = response.data;
                var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                var blob = new Blob([data], { type: contentType });
                var downloadUrl = window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'Project Search Result.xlsx';
                link.click();
            },
            this.errorHandler
        )
    }

    renderPaginationAdvanceSearch() {
        const { currentPage, projects, count } = this.props;
        const rem = count % 10;
        const divCount = Math.floor(count / 10);
        const pageCount = (rem === 0) ? divCount - 1 : divCount;

        if (projects.length === 0) return null;
        return (
            <div className="container">
                <div className="row">
                    <div className="col s12">
                        <ul className="pagination">
                            <li className="prev">{currentPage > 0 ? <a href="# " onClick={this.handleAdvanceSearch(currentPage - 1)}>← Previous</a> : null}</li>
                            <li className="next">{currentPage < pageCount ? <a href="# " onClick={this.handleAdvanceSearch(currentPage + 1)}>Next →</a> : null}</li>
                        </ul>

                    </div>
                </div>
            </div>
        )
    }

    renderResults(name) {
        return (
            <div className="results">

                {name === 'member' && this.state.showInternalDd
                    ? <ul>
                        {this.props.internalTeamMembers.map(leader =>
                            <li key={leader.id} onClick={this.selectMember(leader, 'internal')}>
                                <strong>{leader.member.firstName + ' ' + leader.member.lastName}</strong>
                            </li>
                        )}
                    </ul>
                    : null}

                {name === 'consultant' && this.state.showExternalDd
                    ? <ul>
                        {this.props.externalTeamMembers.map(leader =>
                            <li key={leader.id} onClick={this.selectMember(leader, 'external')} >
                                <strong>{leader.externalConsultant.firstName + ' ' + leader.externalConsultant.lastName}</strong>
                            </li>
                        )}
                    </ul>
                    : null}
            </div>
        );
    }

    render() {
        const { projectId, divisionName, unitName, phaseName, subPhase, sponsor,
            benchmarkStatus, since1996, designFiscalYear,
            constructionFiscalYear, designBy, designGroup, cmBoro, isFHWA,
            regNumber, vendorName, regDateFrom, regDateTo, borough, communityBoard,
            cityCouncil, assemblyDist, stateSenateDist, usCongressionalDist, paunit, queryMembers, queryConsultants, internalMemberId, externalConsultantId } = this.state;

        const { projectTypes, projectProgramTypes, projects, count } = this.props;

        const selectProjectTypesName = 'projectTypes';
        const selectConstructionFiscalYearName = 'constructionFiscalYears';
        const selectDesignFiscalYearName = 'selectDesignFiscalYears';

        let canSubmit = false;
        if ((sponsor !== undefined && sponsor !== '') || (phaseName !== undefined && phaseName !== '') ||
            (this.state.designFiscalYear !== undefined && this.state.designFiscalYear !== '') || (this.state.constructionFiscalYear !== undefined && this.state.constructionFiscalYear !== '') ||
            (projectId !== undefined && projectId !== '') || (divisionName !== undefined && divisionName !== '') ||
            (unitName !== undefined && unitName !== '') || (regNumber !== undefined && regNumber !== '') || (vendorName !== undefined && vendorName !== '') ||
            (designGroup !== undefined && designGroup !== '') || (cityCouncil !== undefined && cityCouncil !== '') || (assemblyDist !== undefined && assemblyDist !== '') ||
            (stateSenateDist !== undefined && stateSenateDist !== '') || (usCongressionalDist !== undefined && usCongressionalDist !== '') ||
            (communityBoard !== undefined && communityBoard !== '') || (borough !== undefined && borough !== '') || (designBy !== undefined && designBy !== '') ||
            (cmBoro !== undefined && cmBoro !== '') || (benchmarkStatus !== undefined && benchmarkStatus !== '') || (since1996 !== undefined && since1996 !== '') || (isFHWA !== undefined && isFHWA !== '') ||
            (regDateFrom !== undefined && regDateFrom !== '') || (regDateTo !== undefined && regDateTo !== '') ||
            (this.state.advanceSearchProjectTypesSelected !== undefined && this.state.advanceSearchProjectTypesSelected !== '') ||
            (this.state.advanceSearchProgramTypeSelected !== undefined && this.state.advanceSearchProgramTypeSelected) ||
            (paunit !== undefined && paunit !== '') || (internalMemberId !== undefined && internalMemberId !== '') ||
            (externalConsultantId !== undefined && externalConsultantId !== '')) {
            canSubmit = true;
        }

        return (
            <div>
                <div className="container">
                    <form onSubmit={this.handleAdvanceSearch(0)}>
                        <div>
                            <div className="row margin-top-1">
                                <div className="col l2 m4 s6">
                                    <label className="label-select-search">Project ID</label>
                                    <div className="search-box search-box-small margin-bottom-0">
                                        <input type="text" autoFocus
                                            className="search-input"
                                            value={projectId} onChange={this.handleChangeProjectId('ProjectId')}
                                        />
                                    </div>
                                </div>

                                <div className="col l2 m4 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Division</label>
                                        <Select name={divisionName}
                                            value={divisionName}
                                            options={this.getOptionsForDivision(divisionName)}
                                            onChange={this.handleSelectChangeDivision(divisionName)}
                                        />
                                    </div>
                                </div>

                                <div className="col l2 m4 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Unit</label>
                                        <Select name={unitName}
                                            value={unitName}
                                            options={this.getOptionsForUnit(unitName)}
                                            onChange={this.handleSelectChange('unitName')}
                                        />
                                    </div>
                                </div>
                                {(divisionName !== '' && divisionName !== null && !since1996) ?
                                    <div className="col l2 m4 s6">
                                        <label className="label-select-search">Phase</label>
                                        <div className="controls with-select">
                                            <Select name={phaseName}
                                                value={phaseName}
                                                options={this.getOptionsForPhase(phaseName)}
                                                onChange={this.handleSelectChangePhase(phaseName)}
                                            />
                                        </div>
                                    </div> : null}
                                {(divisionName !== '' && divisionName !== null && !since1996) ?
                                    <div className="col l2 m4 s6">
                                        <label className="label-select-search">Subphase</label>
                                        <div className="controls with-select">
                                            <Select name={subPhase}
                                                value={subPhase}
                                                options={this.getOptionsForSubPhase(this.props.subPhases.filter(p => p.phaseName === phaseName && divisionName === p.divisionName))}
                                                onChange={this.handleSelectChangesubPhase(subPhase)}
                                            />
                                        </div>
                                    </div> : null}

                                <div className="col l2 m4 s6">
                                    <label className="label-select-search">Sponsor</label>
                                    <div className="controls with-select">
                                        <Select name={sponsor}
                                            value={sponsor}
                                            options={this.getOptionsForSponsor(sponsor)}
                                            onChange={this.handleSelectChange('sponsor')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row margin-top-075">
                                <div className="col l2 m4 s6">
                                    <label className="label-select-search">Status</label>
                                    <div className="controls with-select">
                                        <Select multi name={benchmarkStatus}
                                            value={benchmarkStatus}
                                            options={this.getOptionsForStatus(benchmarkStatus)}
                                            //onChange={this.handleSelectChange('benchmarkStatus')}
                                            onChange={this.handleSelectChangeStatusMulti}
                                        />
                                    </div>
                                </div>

                                {divisionName !== '' && divisionName !== null
                                    ? <div>
                                        <div className="col l4 m8 s12 multi-select-custom">
                                            <label className="label-select-search">Project Type</label>
                                            <Select multi name={selectProjectTypesName}
                                                value={this.state.advanceSearchProjectTypesSelected}
                                                options={getOptionsForProjectType(projectTypes, divisionName)}
                                                onChange={this.handleSelectChangeMulti}
                                            />
                                        </div>

                                        <div className="col l2 m4 s6">
                                            <label className="label-select-search">Program Type</label>
                                            <Select name="programType"
                                                value={this.state.advanceSearchProgramTypeSelected}
                                                options={getOptionsForProgramType(projectProgramTypes, divisionName)}
                                                onChange={this.handleSelectChange('advanceSearchProgramTypeSelected')}
                                            />
                                        </div>
                                    </div>
                                    : null}

                                <div className="col l2 m4 s6">
                                    <label className="label-select-search">Priority</label>
                                    <Select name="Priority"
                                        value={this.state.advanceSearchPriority}
                                        options={this.getOptionsFor('priorities')}
                                        onChange={this.handleSelectChange('advanceSearchPriority')}
                                    />
                                </div>
                                {(divisionName !== '' && divisionName !== null && divisionName === PUBLICBUILDING) &&
                                    <div className="col l2 m4 s6">
                                        <label className="label-select-search">Project Delivery Method</label>
                                        <Select name="projectDeliveryMethod"
                                            value={this.state.projectDeliveryMethod}
                                            options={this.getOptionsForProjectDeliveryMethod('projectdeliverymethod')}
                                            onChange={this.handleSelectChange('projectDeliveryMethod')}
                                        />
                                    </div>}
                            </div>

                            {(divisionName !== '' && divisionName !== null && divisionName === INFRASTRUCTURE) &&
                                <div className="row margin-top-075">

                                    <div className="col l2 m4 s6 multi-select-custom">
                                        <label className="label-select-search">Design Fiscal Year</label>
                                        <Select multi name={selectDesignFiscalYearName}
                                            value={this.state.designFiscalYear}
                                            options={this.getOptionsForFiscalYear(designFiscalYear)}
                                            onChange={this.handleSelectChangeDesignFyMulti}
                                        />
                                    </div>

                                    <div className="col l2 m4 s6 multi-select-custom">
                                        <label className="label-select-search">Construction Fiscal Year</label>
                                        <Select multi name={selectConstructionFiscalYearName}
                                            value={this.state.constructionFiscalYear}
                                            options={this.getOptionsForFiscalYear(constructionFiscalYear)}
                                            onChange={this.handleSelectChangeCfyMulti}
                                        />
                                    </div>

                                    <div className="col l1 m3 s6">
                                        <label className="label-select-search">Design By</label>
                                        <div className="controls with-select">
                                            <Select name={designBy}
                                                value={designBy}
                                                options={this.getOptionsForDesignBy(designBy)}
                                                onChange={this.handleSelectChange('designBy')}
                                            />
                                        </div>
                                    </div>

                                    <div className="col l1 m4 s6">
                                        <label className="label-select-search">Design Group</label>
                                        <div className="controls with-select">
                                            <Select name={designGroup}
                                                value={designGroup}
                                                options={this.getOptionsForDesignGroup(designGroup)}
                                                onChange={this.handleSelectChange('designGroup')}
                                            />
                                        </div>
                                    </div>

                                    <div className="col l2 m4 s6">
                                        <label className="label-select-search">CM Boro</label>
                                        <div className="controls with-select">
                                            <Select name={cmBoro}
                                                value={cmBoro}
                                                options={this.getOptionsForCMBoro(cmBoro)}
                                                onChange={this.handleSelectChange('cmBoro')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l2 m3 s6">
                                        <div className="md-checkbox margin-top-30">
                                            <input id="fed-funded" type="checkbox" onChange={() => this.handleCheckboxChangeFHWA()} checked={isFHWA} />
                                            <label htmlFor="fed-funded" className="label-color">FHWA Funded</label>
                                        </div>
                                    </div>

                                </div>
                            }


                            <div className="padding-left-075 cursor-pointer" onClick={this.toggleVendorInfo}>
                                <h3 className="text-center margin-bottom-075" id="hoverBlue">Vendor Information</h3>
                            </div>

                            {!this.state.isHiddenVendor
                                ? <div className="row margin-top-075">
                                    <div className="grey-border-custom margin-left-075 margin-right-075" id="grey-border-media-medium">

                                        <div className="col l2 m3 s6">
                                            <label className="label-select-search">Registration Number</label>
                                            <div className="search-box search-box-small">
                                                <input
                                                    className="search-input"
                                                    type="text"
                                                    onChange={this.handleChange('regNumber')}
                                                    value={regNumber}
                                                />
                                            </div>
                                        </div>

                                        <div className="col l3 m7 s6">
                                            <label className="label-select-search">Vendor Name</label>
                                            <div className="search-box search-box-small">
                                                <input
                                                    className="search-input"
                                                    type="text"
                                                    onChange={this.handleChange('vendorName')}
                                                    value={vendorName}
                                                />
                                            </div>
                                        </div>

                                        <div className="col l2 m3 s12 offset-l1">
                                            <label className="label-select-search">Registration Date From</label>
                                            <div className="date-input-custom-search">
                                                <DateField limits={{}}
                                                    value={regDateFrom}
                                                    onChange={this.handleDateChangeReg('regDateFrom')}
                                                />
                                            </div>
                                        </div>

                                        <div className="col l2 m3 s12">
                                            <label className="label-select-search">Registration Date To</label>
                                            <div className="date-input-custom-search">
                                                <DateField limits={{}}
                                                    value={regDateTo}
                                                    onChange={this.handleDateChangeReg('regDateTo')}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                : null}

                            <div className="padding-left-075 cursor-pointer" onClick={this.toggleGeoLocations}>
                                <h3 className="text-center margin-bottom-075" id="hoverBlue">Geo Locations</h3>
                            </div>

                            {!this.state.isHiddenGeo &&
                                <div className="row margin-top-075">
                                    <div className="grey-border-custom">
                                        <div className="col l2 m2 s6">
                                            <div className="controls with-select">
                                                <label className="label-select-search">Borough</label>
                                                <Select name={borough}
                                                    value={borough}
                                                    options={this.getOptionsForBorough(borough)}
                                                    onChange={this.handleSelectChange('borough')}
                                                />
                                            </div>
                                        </div>

                                        <div className="col l2 m2 s6">
                                            <div className="controls with-select">
                                                <label className="label-select-search">Community Board</label>
                                                <Select name={communityBoard}
                                                    value={communityBoard}
                                                    options={this.getOptionsForComBoard()}
                                                    onChange={this.handleSelectChange('communityBoard')}
                                                />
                                            </div>
                                        </div>
                                        <div className="col l2 m2 s6">
                                            <div className="controls with-select">
                                                <label className="label-select-search">City Council District</label>
                                                <Select name={cityCouncil}
                                                    value={cityCouncil}
                                                    options={this.getOptionsForcityCouncil()}
                                                    onChange={this.handleSelectChange('cityCouncil')}
                                                />
                                            </div>
                                        </div>
                                        <div className="col l2 m2 s6">
                                            <div className="controls with-select">
                                                <label className="label-select-search">Assembly District</label>
                                                <Select name={assemblyDist}
                                                    value={assemblyDist}
                                                    options={this.getOptionsForAssemblyDist()}
                                                    onChange={this.handleSelectChange('assemblyDist')}
                                                />
                                            </div>
                                        </div>
                                        <div className="col l2 m2 s6">
                                            <div className="controls with-select">
                                                <label className="label-select-search">State Senate District</label>
                                                <Select name={stateSenateDist}
                                                    value={stateSenateDist}
                                                    options={this.getOptionsForStateSenate()}
                                                    onChange={this.handleSelectChange('stateSenateDist')}
                                                />
                                            </div>
                                        </div>
                                        <div className="col l2 m2 s6">
                                            <div className="controls with-select">
                                                <label className="label-select-search">US Congressional District</label>
                                                <Select name={usCongressionalDist}
                                                    value={usCongressionalDist}
                                                    options={this.getOptionsForUSCongressional()}
                                                    onChange={this.handleSelectChange('usCongressionalDist')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="row margin-top-075">
                                {(phaseName === '' || phaseName === null) &&
                                    <div className="col l2 m4">
                                        <div className="md-checkbox">
                                            <input id="bp-received" type="checkbox" onChange={() => this.handleCheckboxChange()} checked={since1996} />
                                            <label htmlFor="bp-received" className="label-color">Include projects since 1996</label>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="padding-left-075 cursor-pointer" onClick={this.toggleProjectTeam}>
                                <h3 className="text-center margin-bottom-075" id="hoverBlue">Project Team</h3>
                            </div>

                            {!this.state.isHiddenTeam &&
                                <div className="row margin-top-075">
                                    <div className="grey-border-custom margin-left-075 margin-right-075">

                                        <div className="col l2 m6 offset-l2 s6">
                                            <div className="controls with-select position-relative">
                                                <label className="label-select-search">Team Member</label>
                                                <div className="section-search search-ae search-member">
                                                    <div className="box-wrap">
                                                        <input type="text" name="queryMembers"
                                                            value={queryMembers}
                                                            onChange={this.handleTeamSearch('member')}
                                                            placeholder="Search for team members ..."
                                                            autoComplete="off" />
                                                    </div>
                                                    {queryMembers ? this.renderResults('member', true) : null}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col l2 m3 offset-l2 s6">
                                            <div className="controls with-select position-relative">
                                                <label className="label-select-search">External Consultant</label>
                                                <div className="section-search search-ae search-member">
                                                    <div className="box-wrap">
                                                        <input type="text" name="queryConsultants"
                                                            value={queryConsultants}
                                                            onChange={this.handleTeamSearch('consultant')}
                                                            placeholder="Search for external consultants ..."
                                                            autoComplete="off" />
                                                    </div>
                                                    {queryConsultants ? this.renderResults('consultant') : null}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }

                            <div className="row search-btns">
                                <button className="btn-save" type="submit" disabled={!canSubmit}>
                                    <span className="margin-right-05"> <MdSearch size={18} color='#1180BA' /></span>
                                    Search
                                </button>
                                <button className="btn-save btn-reset" type="reset" color='#3A4454' onClick={this.handleReset}>
                                    <span className="margin-right-05"> <MdRefresh size={18} color='#3A4454' /></span>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                {!this.props.isHidden &&
                    <div className="row-wide">
                        {projects.length > 0 ?
                            <div className="row" id="advanceSearchExcelCont">
                                <div className="col s2">
                                    <p>Results: {count}</p>
                                </div>
                                <div className="col s10">
                                    <button className="btn-save btn-excel float-right" type="button" onClick={this.handleAdvanceSearchExcel}>
                                        <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                                        Excel</button>
                                </div>
                            </div>
                            : null}
                        <div className="col s12">
                            <div className="table-wrap advance-search-table table-scroll">
                                <table className="table-striped">
                                    {projects.length > 0 ?
                                        <thead>
                                            <tr>
                                                <th>Project ID</th>
                                                <th>FMS ID</th>
                                                <th>Project Title</th>
                                                <th>Current Phase</th>
                                                <th>Sub Phase</th>
                                                <th>Division</th>
                                                <th>Unit</th>
                                                <th>Const. Budget Cost</th>
                                                <th>Design Start (P)</th>
                                                <th>Design Start (A)</th>
                                                <th>Const. start (P)</th>
                                                <th>Const. start (A)</th>
                                                <th>Design Compl. (P)</th>
                                                <th>Design Compl. (A)</th>
                                                <th>Const. Compl. (P)</th>
                                                <th>Const. Compl. (A)</th>
                                                <th>Since 1996</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        : null}
                                    <tbody>
                                        {projects.map(project => {
                                            return project.since1996 === '1' ?
                                                <tr key={project.projectId}>
                                                    <td>{project.projectId}</td>
                                                    <td>{project.fmsids.map(f => f.fmsid).join(', ')}</td>
                                                    <td>{project.projectDescription}</td>
                                                    <td>{project.phase}</td>
                                                    <td>{project.subPhase}</td>
                                                    <td>{project.divisionName}</td>
                                                    <td>{project.unitName}</td>
                                                    <td>{formatMoney(project.plannedAmount)}</td>
                                                    <td>{formatDate(project.schedule.designStart.projected)}</td>
                                                    <td>{formatDate(project.schedule.designStart.actual)}</td>
                                                    <td>{formatDate(project.schedule.constructionStart.projected)}</td>
                                                    <td>{formatDate(project.schedule.constructionStart.actual)}</td>
                                                    <td>{formatDate(project.schedule.designCompletion.projected)}</td>
                                                    <td>{formatDate(project.schedule.designCompletion.actual)}</td>
                                                    <td>{formatDate(project.schedule.constructionCompletion.projected)}</td>
                                                    <td>{formatDate(project.schedule.constructionCompletion.actual)}</td>
                                                    <td>Yes</td>
                                                    <td>{project.benchmarkStatus}</td>
                                                </tr>
                                                :
                                                <tr key={project.projectId} onClick={() => this.redirectToProject(project.projectId)}>
                                                    <td>{project.projectId}</td>
                                                    <td>{project.fmsids.map(f => f.fmsid).join(', ')}</td>
                                                    <td>{project.projectDescription}</td>
                                                    <td>{project.phase}</td>
                                                    <td>{project.subPhase}</td>
                                                    <td>{project.divisionName}</td>
                                                    <td>{project.unitName}</td>
                                                    <td>{formatMoney(project.plannedAmount)}</td>
                                                    <td>{formatDate(project.schedule.designStart.projected)}</td>
                                                    <td>{formatDate(project.schedule.designStart.actual)}</td>
                                                    <td>{formatDate(project.schedule.constructionStart.projected)}</td>
                                                    <td>{formatDate(project.schedule.constructionStart.actual)}</td>
                                                    <td>{formatDate(project.schedule.designCompletion.projected)}</td>
                                                    <td>{formatDate(project.schedule.designCompletion.actual)}</td>
                                                    <td>{formatDate(project.schedule.constructionCompletion.projected)}</td>
                                                    <td>{formatDate(project.schedule.constructionCompletion.actual)}</td>
                                                    <td>No</td>
                                                    <td>{project.benchmarkStatus}</td>
                                                </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                }

                {!this.props.isHidden ? this.renderPaginationAdvanceSearch() : null}
                {this.props.errorMessage ? <div className="pagination error-text">{this.props.errorMessage}</div> : null}

            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        subPhases: state.projectsStore.subPhases,
        projectTypes: state.additionalProjectsStore.projectTypes,
        projectProgramTypes: state.additionalProjectsStore.projectProgramTypes,
        priorities: state.projectsStore.setup.priorities,
        gisCouncil: state.projectsStore.gisCouncil,
        gisAssemblyDist: state.projectsStore.gisAssemblyDist,
        gisCommBoard: state.projectsStore.gisCommBoard,
        gisStateSenateDist: state.projectsStore.gisStateSenateDist,
        gisUSCongressionalDist: state.projectsStore.gisUSCongressionalDist,
        projects: state.projectsStore.projects,
        currentPage: state.projectsStore.currentPage,
        count: state.projectsStore.projectsCount,
        errorMessage: state.projectsStore.errorMessage,
        internalTeamMembers: state.additionalProjectsStore.internalTeamMembers,
        externalTeamMembers: state.additionalProjectsStore.externalTeamMembers
    }
}

export default connect(mapStateToProps, {
    fetch_lkp_ProjectType, fetch_lkp_ProjectProgramType,
    fetchGisCityCouncils, fetchGisAssemblyDist, fetchGisCommBoard, fetchProjectsAdvance,
    setEmptyProjects, fetchInternalTeam, fetchExternalTeam, fetchGisStateSenateDist, fetchGisUSCongressionalDist,
})(AdvanceSearch);